import { useCallback, useState } from 'react';

import DropdownIcon from '../../icons/dropdown.icon';

import styles from './status-filter-button.module.scss';

interface Props {
    defaultValue?: number;
    statusList: { text: string; value: number }[];
    onSelect: (status: { text: string; value: number }) => void;
}

const StatusFilterButton = ({ defaultValue, statusList, onSelect }: Props) => {
    const [selected, setSelected] = useState(statusList[0]);

    const getByDefaultValue = useCallback(
        (value?: number) => {
            if (!value) return undefined;
            return statusList.find((status) => status.value === value);
        },
        [statusList]
    );

    const onChange = (value: string) => {
        const selectedValue = statusList.find(
            (status) => status.value === Number(value)
        );
        setSelected(selectedValue!);
        onSelect(selectedValue!);
    };

    return (
        <div className={styles.container}>
            <span>
                Estado: {getByDefaultValue(defaultValue)?.text ?? selected.text}
            </span>
            <select
                defaultValue={
                    getByDefaultValue(defaultValue)?.value ??
                    statusList[0].value
                }
                onChange={(ev) => onChange(ev.target.value)}
            >
                {statusList.map((status) => (
                    <option key={status.value} value={status.value}>
                        {status.text}
                    </option>
                ))}
            </select>
            <div className={styles.dropdownContainer}>
                <DropdownIcon size={18} color={'#414552'} />
            </div>
        </div>
    );
};

export default StatusFilterButton;
